module.exports = __webpack_public_path__ + "img/house.886d2bbb.svg";